import BlackFridayImage from "../../assets/black-friday.png"
import ButtonSpinner from "../_common/components/buttons/buttonSpinner/buttonSpinner"
import MatriculacionModal from "../matriculacion-modal/matriculacion-modal"
import Modal from "../_common/components/Modal"
import crypto from 'crypto'
import { connect } from "react-redux"
import { h, Fragment } from "preact"
import { isSpanishUser } from "../_common/utils/getLang"
import { t } from '../_i18n'
import { toastService } from "../_services/toast-service"
import { useState, useEffect } from 'preact/hooks'

import './black-friday.scss'

const BlackFriday = ({ user, studentMeta }) => {
    /** Variables **/
    const isPremiumUser = studentMeta?.has_whatsapp && studentMeta?.shop_id !== 24
    const isMad = studentMeta.formative_zone === 'MAD'
    const semesterId = isMad ? 90 : 84
    const endDate = new Date('2025-11-30T23:59:59')
    const isSpanish = isSpanishUser(studentMeta.shop_id)

    /** States **/
    const [timeLeft, setTimeLeft] = useState({
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
    })
    const [showModal, setShowModal] = useState(false)
    const [loadingSkeleton, setLoadingSkeleton] = useState(false)
    const [showBlackFridayBanner, setShowBlackFridayBanner] = useState(false)
    const [loadingContinue, setLoadingContinue] = useState(false)
    const [cartData, setCartData] = useState(null)
    const [premiumSelected, setPremiumSelected] = useState(isPremiumUser)
    const [selectedProducts, setSelectedProducts] = useState([])
    const [cartDataAlreadyLoaded, setCartDataAlreadyLoaded] = useState()
    const [toValidate, setToValidate] = useState()
    const [generatedMadCartURL, setGeneratedMadCartURL] = useState(null)

    /** Lifcycles **/
    useEffect(() => {
        updateCountdown()
        const interval = setInterval(updateCountdown, 1000)
        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        (async () => {
            const result = await checkBlackFridayBanner()
            setShowBlackFridayBanner(result)
        })()
    }, [])

    /** Methods **/
    const isLastWeekOfNovember = () => {
        const now = new Date()

        const year = now.getFullYear()
        const lastWeekStart = new Date(year, 10, 21)
        const lastWeekEnd = new Date(year, 10, 30, 23, 59, 59)

        return now >= lastWeekStart && now <= lastWeekEnd
    }

    const checkBlackFridayBanner = () => {
        if (!isSpanish && !isMad) return false

        try {
            const zoneCode = studentMeta.formative_zone_code

            const program = (studentMeta.unfinished_academic_programs || [])
                .find(p => p.formative_zone_code === zoneCode)

            if (!program?.formative_actions) return false

            const formativeActions = program.formative_actions

            const allSubjects = formativeActions
                .map(formativeAction => formativeAction?.shop_code?.trim())
                .filter(code => code !== '')

            const studentSubjects = (studentMeta.coursing_or_finished_enrolls || [])
                .filter(enroll => enroll.formative_zone_code === zoneCode)
                .map(enroll => enroll?.formative_action?.shop_code?.trim())
                .filter(code => code !== '')

            const missing = allSubjects.filter(code => {
                const formativeAction = formativeActions.find(a => a?.shop_code?.trim() === code)

                if (formativeAction?.is_enrollable === false) return false

                return !studentSubjects.includes(code)
            })

            return missing.length >= 2

        } catch (error) {
            console.error("Error en checkBlackFridayBanner:", error)
            return false
        }
    }

    const updateCountdown = () => {
        const now = new Date().getTime()
        const distance = endDate.getTime() - now

        if (distance <= 0) {
            setTimeLeft({ hours: '00', minutes: '00', seconds: '00' })
            return
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24))
        const hours = Math.floor((distance / (1000 * 60 * 60)) % 24)
        const minutes = Math.floor((distance / (1000 * 60)) % 60)
        const seconds = Math.floor((distance / 1000) % 60)

        setTimeLeft({
            days: String(days).padStart(2, '0'),
            hours: String(hours).padStart(2, '0'),
            minutes: String(minutes).padStart(2, '0'),
            seconds: String(seconds).padStart(2, '0')
        })
    }

    const encryptString = (studentId) => {
        const cipher = crypto.createCipheriv(
            micuentaenv.ENCRYPTION_METHOD,
            adaptKey(micuentaenv.API_ADMIN_KEYWORD),
            micuentaenv.IV_ENCRYPTION_STRING
        )
        return encodeURIComponent(Buffer.from(
            cipher.update(studentId, 'utf8', 'base64') + cipher.final('base64')
        ).toString())
    }

    const adaptKey = (key) => {
        const len = 32
        if (key.length >= len) {
            return key.substring(0, len)
        } else {
            return key + Array(len - key.length + 1).join("\x00")
        }
    }

    const openModal = async () => {
        if (isMad) {
            if (loadingContinue) return
            setLoadingContinue(true)
            const cart = await getCart()
            if (cart.cartUrl) setGeneratedMadCartURL(cart.cartUrl)
            setLoadingContinue(false)
            return
        }

        setShowModal(true)
    }

    const openNewWindow = () => {
        generatedMadCartURL && window.open(generatedMadCartURL, "_blank")
    }

    const getCart = async (products = []) => {
        try {
            let baseUrl =
                `${micuentaenv.STUDENT_ACCOUNT_API_basePath}/get_recommended_cart_black_friday` +
                `?s=${encryptString(user.id.toString())}` +
                `&as=${semesterId}`

            if (products && Array.isArray(products) && products.length > 0) {
                const formattedProducts = products
                    .filter(p => !!p)
                    .join(',')
                const productsEncrypted = encryptString(formattedProducts)
                baseUrl += `&fa=${productsEncrypted}`
            } else {
                const emptyEncrypted = encryptString('')
                baseUrl += `&fa=${emptyEncrypted}`
            }

            const res = await fetch(baseUrl, {
                headers: { accept: 'application/json' },
                method: 'GET'
            })

            const data = await res.json()

            if (data.code && data.code !== 200) {
                throw new Error(data.message || 'Ha ocurrido un error')
            }

            return data
        } catch (error) {
            console.error("Error en getCart:", error?.message)
            toastService.showToast({ message: "Se ha producido un error al cargar el carrito", type: 'danger' })
            setShowModal(false)
            return null
        }
    }

    const handleCloseModal = () => {
        setCartDataAlreadyLoaded(true)
        setShowModal(false)
    }

    const handleCalculateDiscount = async (products, initial) => {
        if(initial) {
            setLoadingSkeleton(true)
            const cart = await getCart()
            setLoadingSkeleton(false)
            
            const recommendedIds = getRecommendedProducts(cart)
            setSelectedProducts(recommendedIds)

            setCartData(cart)
        } else {
            setLoadingContinue(true)
            const cart = await getCart(products)
            setLoadingContinue(false)

            setCartData(cart)
        }
    }

    const handleContinue = async () => {
        if (cartData.cartUrl) {
            window.open(cartData.cartUrl, "_blank")
        }
    }

    const getRecommendedProducts = (cart) => {
        if (!cart?.semesters) return []
        return cart.semesters?.flatMap(({ products }) => {
            return products
                .filter((product) => product.price > 0)
                .filter((product) => product.is_recommended)
                .map((product) => product.id_product)
        })
    }

    /** Return **/
    return (
        showBlackFridayBanner && isLastWeekOfNovember() && (
            <Fragment>
                <div className="black-friday-card d-flex flex-column lg-flex-row flex-left">
                    <div className="d-flex flex-column lg-flex-row gap-3">
                        <img src={BlackFridayImage} alt="Black Friday iLERNA 2025" className="black-friday-card__image" />
                        <div className="black-friday-card__container d-flex flex-column gap-2 flex-space-between">
                            <h2 className="black-friday-card__title no-margin">
                                <strong>{t('Todos los días son viernes con un 10% de descuento')}</strong>
                            </h2>
                            <div className="width-fit-content">
                                <div className="black-friday-card__badge font-14">
                                    <strong>{t('Esta semana')}</strong>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex flex-column gap-1 flex-space-between">
                            <div className="black-friday-card__countdown d-flex flex-center-x full-width gap-1 no-margin flex-space-between">
                                <div>
                                    <p className="black-friday-card__ends-in no-margin nowrap"><strong>{t('Acaba en...')}</strong></p>
                                </div>
                                <div className="d-flex flex-center-y gap-1 full-width flex-space-between">
                                    <div>
                                        <p className="no-margin t-right font-26">{timeLeft.days}</p>
                                        <p className="no-margin t-right font-14">{t('días')}</p>
                                    </div>
                                    <div>
                                        <p className="no-margin"><strong>:</strong></p>
                                    </div>
                                    <div>
                                        <p className="no-margin t-right font-26">{timeLeft.hours}</p>
                                        <p className="no-margin t-right font-14">{t('hrs')}</p>
                                    </div>
                                    <div>
                                        <p className="no-margin"><strong>:</strong></p>
                                    </div>
                                    <div>
                                        <p className="no-margin t-right font-26">{timeLeft.minutes}</p>
                                        <p className="no-margin t-right font-14">{t('mins')}</p>
                                    </div>
                                    <div>
                                        <p className="no-margin"><strong>:</strong></p>
                                    </div>
                                    <div >
                                        <p className="no-margin t-right font-26">{timeLeft.seconds}</p>
                                        <p className="no-margin t-right font-14">{t('segs')}</p>
                                    </div>
                                </div>
                            </div>
                            <ButtonSpinner
                                showSpinner={loadingContinue}
                                onClick={generatedMadCartURL ? openNewWindow : openModal}
                                btnType="primary"
                            >
                                {generatedMadCartURL ? t('Ir al carrito con descuento') : t('¡Aprovecha el descuento!')}
                            </ButtonSpinner>
                        </div>
                    </div>
                    <div className="d-flex flex-space-between gap-1 flex-bottom gap-1">
                    </div>
                </div>

                {showModal && (
                    <Modal visible={showModal} closeModal={handleCloseModal} overlayClass="modal-overlay black-friday-overlay">
                        <MatriculacionModal
                            cartData={cartData}
                            cartDataAlreadyLoaded={cartDataAlreadyLoaded}
                            isPremiumUser={isPremiumUser}
                            loadingContinue={loadingContinue}
                            loadingSkeleton={loadingSkeleton}
                            onCalculateDiscount={handleCalculateDiscount}
                            onCloseModal={handleCloseModal}
                            onContinue={handleContinue}
                            premiumSelected={premiumSelected}
                            selectedProducts={selectedProducts}
                            setLoadingContinue={setLoadingContinue}
                            setPremiumSelected={setPremiumSelected}
                            setSelectedProducts={setSelectedProducts}
                            setToValidate={setToValidate}
                            title='Black Friday 2025'
                            toValidate={toValidate}
                        />
                    </Modal>
                )}
            </Fragment>
        )
    )
}

/** Redux Container **/
const BlackFridayContainer = connect(
    ({ auth, status }) => ({
        user: auth.loggedUser,
        studentMeta: status.student_meta
    }),
    {}
)(BlackFriday)

/** Export **/
export default BlackFridayContainer
